import { render } from "./MyData.vue?vue&type=template&id=1ecc6964&scoped=true"
import script from "./MyData.vue?vue&type=script&lang=js"
export * from "./MyData.vue?vue&type=script&lang=js"

import "./MyData.vue?vue&type=style&index=0&id=1ecc6964&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ecc6964"]])

export default __exports__